import { PermissionEnum } from '../../../common/permissions/permissions.Enum';
import { getGroupPermissionFactory } from '../../../common/permissions/permissions.utils';
import { getUserManagementModuleName } from './user-management.permissions';

export class ScopesPermissions {
    static GroupName = `${getUserManagementModuleName()}.Scopes`;

    static getPermissions = getGroupPermissionFactory(ScopesPermissions.GroupName);

    static Permissions = {
        Create: ScopesPermissions.getPermissions(PermissionEnum.CREATE),
        Read: ScopesPermissions.getPermissions(PermissionEnum.READ),
        ReadAll: ScopesPermissions.getPermissions(PermissionEnum.READ_ALL),
        Update: ScopesPermissions.getPermissions(PermissionEnum.UPDATE)
    };
}
